module.exports = __webpack_public_path__ + "static/img/hot.8c75d18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/hot.svg
// module id = 6692
// module chunks = 55